import { render } from "./ClinicIntegrationEdit.vue?vue&type=template&id=d81bfcae&scoped=true"
import script from "./ClinicIntegrationEdit.vue?vue&type=script&lang=js"
export * from "./ClinicIntegrationEdit.vue?vue&type=script&lang=js"

import "./ClinicIntegrationEdit.vue?vue&type=style&index=0&id=d81bfcae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81bfcae"]])

export default __exports__